import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import metadataAll from '../data/metaData_AllPages_v1.json';

export const useMetadata = (language = 'ar') => {
    const location = useLocation();

    const setMetadata = useCallback((metadata) => {
        if (!metadata) {
            // Fallback to a default title if no metadata provided
            document.title = 'مسار التميز | Masar Altmaioz';
            return;
        }

        // Set basic meta tags based on language
        const title = metadata[language]?.title || metadata['ar']?.title || 'مسار التميز | Masar Altmaioz';
        document.title = title;

        // Update description with language fallback
        const descriptionTag = document.querySelector('meta[name="description"]');
        if (descriptionTag) {
            descriptionTag.setAttribute('content',
                metadata[language]?.description ||
                metadata['ar']?.description ||
                ''
            );
        }

        // Update SEO meta tags if they exist
        if (metadata.seo) {
            // Set canonical with proper language path
            let canonicalTag = document.querySelector('link[rel="canonical"]');
            if (!canonicalTag) {
                canonicalTag = document.createElement('link');
                canonicalTag.rel = 'canonical';
                document.head.appendChild(canonicalTag);
            }
            const baseUrl = metadata.url.split('/ar')[0];
            canonicalTag.href = `${baseUrl}/${language}${location.pathname}`;

            // Set keywords with language support
            let keywordsTag = document.querySelector('meta[name="keywords"]');
            if (!keywordsTag) {
                keywordsTag = document.createElement('meta');
                keywordsTag.name = 'keywords';
                document.head.appendChild(keywordsTag);
            }
            keywordsTag.content = metadata.seo.meta?.name?.keywords || '';

            // Add language alternates
            const alternateAr = document.querySelector('link[hreflang="ar"]');
            const alternateEn = document.querySelector('link[hreflang="en"]');

            if (!alternateAr) {
                const arLink = document.createElement('link');
                arLink.rel = 'alternate';
                arLink.hreflang = 'ar';
                arLink.href = `${baseUrl}/ar${location.pathname}`;
                document.head.appendChild(arLink);
            }

            if (!alternateEn) {
                const enLink = document.createElement('link');
                enLink.rel = 'alternate';
                enLink.hreflang = 'en';
                enLink.href = `${baseUrl}/en${location.pathname}`;
                document.head.appendChild(enLink);
            }
        }
    }, [language, location]);

    useEffect(() => {
        const currentPath = location.pathname;
        // Remove language prefix for path matching
        const pathWithoutLang = currentPath.replace(/^\/(ar|en)/, '') || '/';
        const normalizedPath = pathWithoutLang.endsWith('/') && pathWithoutLang !== '/'
            ? pathWithoutLang.slice(0, -1)
            : pathWithoutLang;

        // Find matching metadata - with better error handling
        const metadata = metadataAll.find(meta => {
            try {
                const metaUrl = new URL(meta.url);
                const metaPath = metaUrl.pathname.replace(/^\/(ar|en)/, '') || '/';
                const normalizedMetaPath = metaPath.endsWith('/') && metaPath !== '/'
                    ? metaPath.slice(0, -1)
                    : metaPath;

                return normalizedMetaPath === normalizedPath;
            } catch (e) {
                return false;
            }
        });

        if (metadata) {
            setMetadata(metadata);
        } else {
            // Fallback title when no matching metadata is found
            const fallbackTitle = language === 'en'
                ? 'Masar Altmaioz | Digital & Creative Solutions'
                : 'مسار التميز | وكالة تسويق رقمي وإدارة وسائل التواصل الاجتماعي';
            document.title = fallbackTitle;
        }
    }, [location, language, setMetadata]);
};